import { useState } from "react";

import androidStoreImg from "../../../assets/img/apponboarding/android_store.svg";
import appleStoreImg from "../../../assets/img/apponboarding/apple_store.svg";
import installAppImg from "../../../assets/img/apponboarding/install_app.svg";
import { useResponsive } from "../../../customHooks/useResponsive";
import {
  AppLinkRow,
  AppLinksColumn,
  CopyLinkButton,
  InstallAppButtonsContainer,
  InstallSkipButton,
  MediaArea,
  StepCardWrapper,
  StepDescription,
  StepLabel,
  StepMediaCol,
  StepTextCol,
  StepTitle,
  StepTitleGroup,
  StepTitleSubGroup,
  StoreBadge,
  StoreBadgeLink,
} from "../shared/appOnboardingStyles";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/fieldservicely-app/id6472611827";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.fieldservicely.fieldservice.app";

const StepInstallApp = ({
  onSkip,
  stepNumber,
  selectedOrganization,
  completeAppOnboardingStep,
}) => {
  const isOperation = selectedOrganization?.type === "operation";
  const [iosCopied, setIosCopied] = useState(false);
  const [androidCopied, setAndroidCopied] = useState(false);
  const { isMobile, isTablet } = useResponsive();
  const isMobileView = isMobile || isTablet;

  const markStepComplete = () => {
    if (selectedOrganization?.id && completeAppOnboardingStep) {
      completeAppOnboardingStep(selectedOrganization.id, "install_mobile_app");
    }
  };

  const handleCopy = (url, setFlag) => {
    navigator.clipboard.writeText(url).then(() => {
      setFlag(true);
      setTimeout(() => setFlag(false), 2000);
      markStepComplete();
    });
  };

  return (
    <StepCardWrapper>
      <StepTextCol>
        <StepTitleGroup width={isMobileView ? "auto" : "614px"}>
          <StepTitleSubGroup>
            <StepLabel>Step {stepNumber}</StepLabel>
            <StepTitle>Install Mobile App</StepTitle>
          </StepTitleSubGroup>
          <StepDescription>
            {`Download the FieldServicely app so your team can update ${
              isOperation ? "task" : "job"
            } status from the field.`}
          </StepDescription>
        </StepTitleGroup>

        <InstallAppButtonsContainer>
          <InstallSkipButton type="button" onClick={onSkip}>
            Skip
          </InstallSkipButton>
          <AppLinksColumn>
            <AppLinkRow>
              <StoreBadgeLink
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={markStepComplete}
                aria-label="Download on the App Store"
              >
                <StoreBadge
                  src={appleStoreImg}
                  alt="Download on the App Store"
                />
              </StoreBadgeLink>
              <CopyLinkButton
                type="button"
                onClick={() => handleCopy(APP_STORE_URL, setIosCopied)}
              >
                {iosCopied ? "Copied!" : "Copy link"}
              </CopyLinkButton>
            </AppLinkRow>
            <AppLinkRow>
              <StoreBadgeLink
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={markStepComplete}
                aria-label="Get it on Google Play"
              >
                <StoreBadge src={androidStoreImg} alt="Get it on Google Play" />
              </StoreBadgeLink>
              <CopyLinkButton
                type="button"
                onClick={() => handleCopy(PLAY_STORE_URL, setAndroidCopied)}
              >
                {androidCopied ? "Copied!" : "Copy link"}
              </CopyLinkButton>
            </AppLinkRow>
          </AppLinksColumn>
        </InstallAppButtonsContainer>
      </StepTextCol>

      <StepMediaCol>
        <MediaArea
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#F4ECFE",
          }}
        >
          <img
            src={installAppImg}
            alt="Install App"
            style={{
              maxWidth: "80%",
              maxHeight: "80%",
              objectFit: "contain",
            }}
          />
        </MediaArea>
      </StepMediaCol>
    </StepCardWrapper>
  );
};

export default StepInstallApp;
